import type { ApolloLink } from "@apollo/client";
import {
  getApolloAuthLink,
  getClient,
  getUnauthLink,
  setApolloAuthLinkWithConfig,
} from "../get-client";
import {
  PRODUCTS_GRAPHQL_API_BASE_URL,
  USERS_GRAPHQL_API_BASE_URL,
  SM_API_BASE_URL,
  SEARCH_SERVICE_GRAPHQL_API_BASE_URL,
  REWARDS_SERVICE_GRAPHQL_API_BASE_URL,
  CPGPULSE_SERVICE_GRAPHQL_API_BASE_URL,
} from "@stadium/constants/api-endpoints";

const DEFAULT_CLIENT_PARAMS = {
  defaultUri: "products",
  endpoints: {
    products: PRODUCTS_GRAPHQL_API_BASE_URL,
    users: USERS_GRAPHQL_API_BASE_URL,
    search: SEARCH_SERVICE_GRAPHQL_API_BASE_URL,
    rewards: REWARDS_SERVICE_GRAPHQL_API_BASE_URL,
    cpgpulse: CPGPULSE_SERVICE_GRAPHQL_API_BASE_URL,
  },
  restEndpoint: SM_API_BASE_URL,
};

export const apolloClient = getClient(DEFAULT_CLIENT_PARAMS);
export const getApolloInstanceUnAuthLink = () => getUnauthLink(DEFAULT_CLIENT_PARAMS);
export const getApolloInstanceAuthLink = (token) =>
  getApolloAuthLink({ token, ...DEFAULT_CLIENT_PARAMS });
export const setApolloInstanceAuthLinkWithConfig = (options: {
  workspaceLink?: ApolloLink;
  authLink?: ApolloLink;
  user?: Record<string, unknown>;
}) =>
  setApolloAuthLinkWithConfig({
    ...options,
    ...DEFAULT_CLIENT_PARAMS,
  });
